<template functional>
  <ul class="farm-list row list-group">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'FarmList',
};
</script>

<style scoped>
</style>
